import {resources, scopes} from '../../../permissions/dictionary';
import {paths} from '../../../dictionaries/urls';

export const CPD = [
  {
    'name': 'Consulta de Repuestos',
    'path': paths.PartsQueryList,
    'resource': resources.Queries,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {
    'name': 'Cierre de Mes',
    'path': paths.MonthClose,
    'resource': resources.MonthClose,
    'scopes': [scopes.See],
    'icon': 'checking',
  },
  {
    'name': 'Chequeo',
    'path': paths.CheckingPage,
    'resource': resources.BinningChecking,
    'scopes': [scopes.See],
    'icon': 'checking',
  },
  {
    'name': 'Almacenamiento',
    'path': paths.StoragePage,
    'resource': resources.BinningStorage,
    'scopes': [scopes.See],
    'icon': 'storage',
  },
  {
    'name': 'Cierre',
    'path': paths.BinningClose,
    'resource': resources.BinningClose,
    'scopes': [scopes.See],
    'icon': 'closure',
  },
  {
    'name': 'Coches Pendientes',
    'path': paths.StoragePendingCars,
    'resource': resources.StoragePendingCarsList,
    'scopes': [scopes.See],
    'icon': 'pendingCars',
  },
  {
    'name': 'Reimpresión de Etiquetas',
    'path': paths.BinningLabelsReprint,
    'resource': resources.LabelsReprinter,
    'scopes': [scopes.See],
    'icon': 'labelReprint',
  },
  {
    'name': 'Consulta de B. O.',
    'path': paths.BackOrdersReport,
    'resource': resources.BackOrdersReport,
    'scopes': [scopes.See],
    'icon': 'backOrderSearch',
  },
  {
    'name': 'Pedidos Manuales',
    'path': paths.ManualsOrdersList,
    'resource': resources.PickingManualsOrders,
    'scopes': [scopes.See],
    'icon': 'manualOrders',
  },
  {
    'name': 'Dashboard de Picking',
    'path': paths.PickingDashboard,
    'resource': resources.PickingDashboard,
    'scopes': [scopes.See],
    'icon': 'pickingDashboard',
  },
  {
    'name': 'Escaneo',
    'path': paths.Scanning,
    'resource': resources.PickingScanning,
    'scopes': [scopes.See],
    'icon': 'scanning',
  },
  {
    'name': 'Pedidos Internos',
    'path': paths.InternalOrdersList,
    'resource': resources.InternalOrders,
    'scopes': [scopes.See],
    'icon': 'internalOrders',
  },
  {
    'name': 'Transferencias',
    'path': paths.WarehouseTransfer,
    'resource': resources.ManualTransfers,
    'scopes': [scopes.See],
    'icon': 'warehouseTransfer',
  },
  {
    'name': 'Facturación',
    'path': paths.ManualInvoicing,
    'resource': resources.Invoicing,
    'scopes': [scopes.See],
    'icon': 'partInvoice',
  },
];

export const maintenance = [{
  'name': 'Causas de Warehouse Denied',
  'path': paths.WarehouseDenialCausesList,
  'resource': resources.PickingWarehouseDenialCauses,
  'scopes': [scopes.See],
  'icon': 'warehouseDenial',
}, {
  'name': 'Cortes',
  'path': paths.ShiftsList,
  'resource': resources.PickingShifts,
  'scopes': [scopes.See],
  'icon': 'shiftCut',
}, {
  'name': 'Códigos sin etiquetas',
  'path': paths.CodeWithoutLabels,
  'resource': resources.CodeWithoutLabels,
  'scopes': [scopes.See],
  'icon': 'labelReprint',
},
{
  'name': 'Zonas de Picking',
  'path': paths.ZonesList,
  'resource': resources.PickingZones,
  'scopes': [scopes.See],
  'icon': 'zonesMaintenance',
}, {
  'name': 'Ventas y Presupuestos',
  'path': paths.SalesAndBudgetsLoad,
  'resource': resources.SalesAndBudgetsLoad,
  'scopes': [scopes.Create],
  'icon': 'budgetLoad',
}, {
  'name': 'Listado de Ubicaciones',
  'path': paths.WarehouseLocationsList,
  'resource': resources.WarehouseLocations,
  'scopes': [scopes.See],
  'icon': 'locations',
}, {
  'name': 'Creación de Ubicaciones',
  'path': paths.LocationsForm,
  'resource': resources.WarehouseLocationsForm,
  'scopes': [scopes.Create],
  'icon': 'locationsMaintenance',
}, {
  'name': 'Asignación de Ubicaciones',
  'path': paths.LocationsAssignment,
  'resource': resources.LocationAssignment,
  'scopes': [scopes.Edit],
  'icon': 'locationsAssign',
}];

export const inventoryManagement = [{
  'name': 'Análisis de Partes',
  'path': paths.PartsAnalysisList,
  'resource': resources.PartAnalysis,
  'scopes': [scopes.See],
  'icon': 'partsAnalysis',
}, {
  'name': 'Parts Watching',
  'path': paths.PartWatchingList,
  'resource': resources.PartWatching,
  'scopes': [scopes.See],
  'icon': 'partsWatching',
}, {
  'name': 'Matriz ICC',
  'path': paths.IccMatrix,
  'resource': resources.IccMatrix,
  'scopes': [scopes.See],
  'icon': 'iccMatrix',
}, {
  'name': 'Parámetros ICC',
  'path': paths.IccParameters,
  'resource': resources.IccMatrixParameters,
  'scopes': [scopes.See],
  'icon': 'iccParameters',
}, {
  'name': 'Parámetros MAD',
  'path': paths.MadParameters,
  'resource': resources.IccMatrixParameters,
  'scopes': [scopes.See],
  'icon': 'madParameters',
}, {
  'name': 'Mantenimiento de PNC',
  'path': paths.PartNumberCodeQueryList,
  'resource': resources.PartNumberCode,
  'scopes': [scopes.Edit],
  'icon': 'partNumberCode',
}, {
  'name': 'Japan Part Master',
  'path': paths.PartsCatalog,
  'resource': resources.PartsCatalog,
  'scopes': [scopes.Create],
  'icon': 'partsCatalog',
}, {
  'name': 'Mantenimiento de factores de precio',
  'path': paths.PriceFactorsMaintenance,
  'resource': resources.PriceFactorsMaintenance,
  'scopes': [scopes.Edit],
  'icon': 'priceFactors',
}, {
  'name': 'Parámetros de obsolescencia',
  'path': paths.ObsolescenceParams,
  'resource': resources.ObsolescenceParameters,
  'scopes': [scopes.Create],
  'icon': 'obsParams',
}, {
  'name': 'Repuestos especiales',
  'path': paths.SpecialParts,
  'resource': resources.SpecialParts,
  'scopes': [scopes.Create],
  'icon': 'specialPart',
}, {
  'name': 'Cotizador de repuestos',
  'path': paths.PartQuotation,
  'resource': resources.PartQuotation,
  'scopes': [scopes.See],
  'icon': 'partQuotation',
}];

export const ordersManagement = [{
  'name': 'Listado de Agencias',
  'path': paths.DealersAgencies,
  'resource': resources.DealerAgencies,
  'scopes': [scopes.See],
  'icon': 'dealerAgencies',
}, {
  'name': 'Pedidos de stock',
  'path': paths.DealerStockOrders,
  'resource': resources.DealerStockOrders,
  'scopes': [scopes.Create],
  'icon': 'dealerStockOrders',
}, {
  'name': 'Consulta de stock',
  'path': paths.DealerEmergingOrders,
  'resource': resources.DealerEmergingOrders,
  'scopes': [scopes.Create],
  'icon': 'dealerEmergingOrders',
}, {
  'name': 'Pedidos especiales',
  'path': paths.DealerSpecialOrders,
  'resource': resources.DealerSpecialOrders,
  'scopes': [scopes.Create],
  'icon': 'dealerSpecialOrders',
}, {
  'name': 'Descarga del archivo POSS',
  'path': paths.DealerPossDownload,
  'resource': resources.DealerOrdersPossDownload,
  'scopes': [scopes.See],
  'icon': 'possDownload',
}, {
  'name': 'Vehículos inmovilizados',
  'path': paths.DealerOrdersImmobilized,
  'resource': resources.DealerOrdersImmobilized,
  'scopes': [scopes.See],
  'icon': 'possDownload',
}, {
  'name': 'Seguimiento de pedidos',
  'path': paths.DealerOrdersTracking,
  'resource': resources.DealerOrdersTracking,
  'scopes': [scopes.See],
  'icon': 'dealerOrdersTracking',
}, {
  'name': 'Pedidos totales',
  'path': paths.DealerOrdersGroupedManagement,
  'resource': resources.DealerOrdersGroupedManagement,
  'scopes': [scopes.See],
  'icon': 'dealerOrdersTracking',
}, {
  'name': 'Administración de pedidos',
  'path': paths.DealerOrdersManagement,
  'resource': resources.DealerOrdersAdministration,
  'scopes': [scopes.Edit],
  'icon': 'dealerOrdersManagement',
}, {
  'name': 'Autorización de Pedidos',
  'path': paths.ProviderOrdersAuthorizationList,
  'resource': resources.ProviderOrdersAuthorization,
  'scopes': [scopes.Edit],
  'icon': 'providerOrdersAuthorization',
}, {
  'name': 'Gestión de ETAs',
  'path': paths.DealerOrdersEtaManagement,
  'resource': resources.DealerOrdersEtaManagement,
  'scopes': [scopes.See],
  'icon': 'dealersOrdersEtasManagement',
}, {
  'name': 'Reporte de ventas perdidas',
  'path': paths.DealerLostSalesReport,
  'resource': resources.DealerLostSalesReport,
  'scopes': [scopes.See, scopes.PartialSee, scopes.LimitedSee],
  'icon': 'lostSalesReport',
}, {
  'name': 'Importaciones en tránsito',
  'path': paths.ProvidersImportations,
  'resource': resources.ProvidersImportations,
  'scopes': [scopes.See],
  'icon': 'inTransitImports',
}, {
  'name': 'Control de montos en pedidos VOR y Aéreos',
  'path': paths.ProviderOrdersAmountControl,
  'resource': resources.ProviderOrdersAmountLimits,
  'scopes': [scopes.Edit],
  'icon': 'providerOrdersAmountControl',
}, {
  'name': 'Reporte de montos en pedidos VOR y Aéreos',
  'path': paths.ProviderAmountReport,
  'resource': resources.ProviderAmountReport,
  'scopes': [scopes.See],
  'icon': 'ordersAmountLimitsReport',
}];

export const inventoryTransfer = [{
  'name': 'Ajuste de Stock',
  'path': paths.StockAdjustmentList,
  'resource': resources.StockAdjustment,
  'scopes': [scopes.See],
  'icon': 'stockAdjustment',
}];

export const partsReturns = [{
  'name': 'Solicitudes',
  'path': paths.PartsReturns,
  'resource': resources.PartsReturns,
  'scopes': [scopes.Edit],
  'icon': 'partsReturns',
}];

export const kardex = [{
  'name': 'Visualizar Kardex',
  'path': paths.Kardex,
  'resource': resources.Kardex,
  'scopes': [scopes.See],
  'icon': 'kardex',
}];

export const lubricants = [{
  'name': 'Facturación de Lubricantes',
  'path': paths.LubricantsInvoicing,
  'resource': resources.LubricantsInvoicing,
  'scopes': [scopes.Create],
  'icon': 'invoicesDocuments',
}];

export const anticipatedInvoice = [{
  'name': 'Pedidos de Accesorios',
  'path': paths.AccessoriesRequestManagement,
  'resource': resources.AccessoriesRequest,
  'scopes': [scopes.Edit, scopes.See],
  'icon': 'order',
},
{
  'name': 'Pedido de Accesorios Resumen',
  'path': paths.AccessoriesRequestSummary,
  'resource': resources.AccessoriesRequestSummary,
  'scopes': [scopes.See],
  'icon': 'vehicleSalesAndStockSummary',
}];

